import { render, staticRenderFns } from "./EditProductDialog.vue?vue&type=template&id=6805c9ec&scoped=true"
import script from "./EditProductDialog.vue?vue&type=script&lang=js"
export * from "./EditProductDialog.vue?vue&type=script&lang=js"
import style0 from "./EditProductDialog.vue?vue&type=style&index=0&id=6805c9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6805c9ec",
  null
  
)

export default component.exports